/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiDonationsByDateQueryResponse, GetApiDonationsByDateQueryParams, GetApiDonationsByDate400, GetApiDonationsByDate401, GetApiDonationsByDate403, GetApiDonationsByDate500 } from "../../types/GetApiDonationsByDate.ts";
import { getApiDonationsByDateQueryResponseSchema } from "../../zod/AdminPaymentsSchemas/getApiDonationsByDateSchema.ts";

function getGetApiDonationsByDateUrl() {
  const res = { method: 'GET', url: `/api/donations/by-date` as const }  
  return res
}

/**
 * @summary Получить общий список по датам
 * {@link /api/donations/by-date}
 */
export async function getApiDonationsByDate({ params }: { params?: GetApiDonationsByDateQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiDonationsByDateQueryResponse, ResponseErrorConfig<GetApiDonationsByDate400 | GetApiDonationsByDate401 | GetApiDonationsByDate403 | GetApiDonationsByDate500>, unknown>({ method : "GET", url : getGetApiDonationsByDateUrl().url.toString(), params, ... requestConfig })  
  return getApiDonationsByDateQueryResponseSchema.parse(res.data)
}